import { Box, Typography, Link, Paper } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

function Footer({ userCount }) {
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        mt: 6,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'success.main',
          mb: 1,
        }}
      >
        <TrendingUpIcon />
        <Typography variant="body1" fontWeight="medium">
          Trending on Product Hunt
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'text.secondary',
        }}
      >
        <PeopleIcon />
        <Typography variant="body2">
          {userCount.toLocaleString()} people creating QR codes today
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mt: 2,
        }}
      >
        <GitHubIcon fontSize="small" />
        <Link
          href="https://github.com/KwameKai4"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
          sx={{ fontWeight: 500 }}
        >
          KwameKai4
        </Link>
      </Box>

      <Paper
        elevation={0}
        sx={{
          mt: 2,
          px: 2,
          py: 1,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
          This site is for sale
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <EmailIcon fontSize="small" />
          <Link
            href="mailto:kwame.whe@gmail.com"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            kwame.whe@gmail.com
          </Link>
        </Box>
        <Typography variant="caption" color="text.secondary">
          Email for enquiries
        </Typography>
      </Paper>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Made with ❤️ for the community
      </Typography>
    </Box>
  );
}

export default Footer;
